module.exports = __webpack_public_path__ + "static/media/rrss.1861f525.svg";